import { createFileRoute } from "@tanstack/react-router";
import { LaunchCampaignTemplate } from "~/features/launchCampaign/LaunchCampaignTemplate";

// 表示可否（このセッション/当日にまだ未表示か）の判定と /launch-campaign への誘導は
// `_authenticated` の beforeLoad ゲートに一本化する。
// ここ（子ルート）で beforeLoad ガードを持つと、画面マウント時の mark で「表示済み」に変わった後の
// beforeLoad 再評価が自分自身を /discover へ redirect してしまい、動画が一瞬で消える不具合になる。
export const Route = createFileRoute("/_authenticated/launch-campaign")({
  component: LaunchCampaignTemplate,
});
